// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_l8-1";
export var quotedThread = "_l8-0";